import { UserNotificationPreferenceGetResponseType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import {
  Button,
  H5,
  RadioSelector,
  RadioSelectorOption,
} from "@sellar-io/components";
import { InputLabel } from "@sellar-io/components";
import { DialogCTA } from "../../../../../components/modal/Dialog";
import { useUserNotificationPreferenceUpdate } from "../../../../../hooks/api/v2/userNotificationPreference/useUserNotificationPreferenceUpdate";

export const OptInMarketingForm = ({
  UserNotificationPreferences,
  onDismiss,
}: {
  UserNotificationPreferences: UserNotificationPreferenceGetResponseType;
  onDismiss: () => void;
}) => {
  const [marketingOptIn, setMarketingOptIn] = useState(
    UserNotificationPreferences.marketingOptIn ? "yes" : "no",
  );

  const useUserNotificationPreferenceUpdateMutation =
    useUserNotificationPreferenceUpdate(UserNotificationPreferences.id);

  const onSubmit = () => {
    useUserNotificationPreferenceUpdateMutation.mutate(
      {
        marketingOptIn: marketingOptIn === "yes",
      },
      {
        onSuccess: () => onDismiss(),
      },
    );
  };
  const loading = useUserNotificationPreferenceUpdateMutation.isPending;
  return (
    <>
      <InputLabel className={"mb-2"}>Sellar trade mailer</InputLabel>
      <RadioSelector
        onChange={(e) => setMarketingOptIn(e.currentTarget.value)}
        value={marketingOptIn}
        variant="grouped"
      >
        <RadioSelectorOption disabled={loading} value={"yes"}>
          <H5>Yes, I want to receive the weekly trade mailer</H5>
        </RadioSelectorOption>
        <RadioSelectorOption disabled={loading} value={"no"}>
          <H5>No, I do not want to receive the weekly trade mailer</H5>
        </RadioSelectorOption>
      </RadioSelector>
      <DialogCTA>
        <Button loading={loading} onClick={onSubmit}>
          Update
        </Button>
      </DialogCTA>
    </>
  );
};
